<template>
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.5 10.6875C9.08883 10.6875 11.1875 8.58883 11.1875 6C11.1875 5.68934 11.4393 5.4375 11.75 5.4375C12.0607 5.4375 12.3125 5.68934 12.3125 6C12.3125 9.21016 9.71016 11.8125 6.5 11.8125C3.28984 11.8125 0.6875 9.21016 0.6875 6C0.6875 2.78984 3.28984 0.1875 6.5 0.1875C6.81066 0.1875 7.0625 0.439341 7.0625 0.75C7.0625 1.06066 6.81066 1.3125 6.5 1.3125C3.91117 1.3125 1.8125 3.41117 1.8125 6C1.8125 8.58883 3.91117 10.6875 6.5 10.6875Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class LoadingIcon extends Vue {}
</script>

<style scoped>
svg {
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
